import { connect } from 'react-redux';
import { isUserSubscribed, isUserLoggedIn } from 'marketing-website/selectors';

import UpgradeLink from './UpgradeLink';

function mapStateToProps(state) {
  return {
    isSubscribed: isUserSubscribed(state),
    isLoggedIn: isUserLoggedIn(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UpgradeLink);



// WEBPACK FOOTER //
// ./src/components/modules/Header/UpgradeLink/index.js